import React, { useState } from 'react';
import Select from 'react-select';

const UpdateModal = ({ isOpen, setIsOpen }) => {
    const [image, setImage] = useState(null);

    if (!isOpen) return null;

    const statusOptions = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
    ];

    const teamOptions = [
        { value: 'team1', label: 'Team 1' },
        { value: 'team2', label: 'Team 2' },
        { value: 'user1', label: 'User 1' },
        { value: 'user2', label: 'User 2' },
    ];

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
        }
    };

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Service/Offering Details</h2>
                <form className="oms-modal-form">
                    <div className="oms-form-group">
                        <label htmlFor="image" className="oms-form-label">
                            Upload Image
                        </label>
                        <input 
                            type="file" 
                            id="image" 
                            accept="image/*" 
                            onChange={handleImageChange} 
                        />
                        {image && <img src={image} alt="Uploaded Preview" style={{ width: '100px', marginTop: '10px' }} />}
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="headline" className="oms-form-label">
                            Headline
                        </label>
                        <input type="text" id="headline" placeholder="Enter headline" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="description" className="oms-form-label">
                            Description
                        </label>
                        <textarea id="description" placeholder="Enter description" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="url" className="oms-form-label">
                            URL
                        </label>
                        <input type="url" id="url" placeholder="Enter URL" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="team" className="oms-form-label">
                            Team/User
                        </label>
                        <Select options={teamOptions} placeholder="Select team or user" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        <Select options={statusOptions} placeholder="Select status" />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UpdateModal;
